import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import Translation, { translate } from "../../utils/Translation";
import "./Header.css";
// @ts-ignore - ignore type resolution for png assets
import HotelIcon from "../../img/v2/hotel.png";

const Header = ({ hotelName, hId, onMesHotelsClick }) => {
  const { lang, setLang } = useContext(HotelContext);

  return (
    <div className="v2-header">
      <h1 className="v2-header__title">
        {hotelName || (hId ? translate("v2_header_hotel_fallback", lang, { id: hId }) : translate("v2_header_select_hotel", lang))}
      </h1>
      <div className="v2-header__actions">
        <button
          type="button"
          className="v2-header__lang"
          onClick={() => setLang(lang === "fr" ? "en" : "fr")}
        >
          {lang.toUpperCase()}
        </button>
        <button className="v2-header__mes-hotels" onClick={onMesHotelsClick}>
          <span className="v2-header__icon-wrap">
            <img
              src={HotelIcon}
              alt={translate("v2_header_hotel_icon_alt", lang)}
              className="v2-header__icon"
            />
          </span>
          <span>
            <Translation tag="Mes_hotels" />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Header;
